module.exports = __webpack_public_path__ + "h5/media/full.caf73be1.mp3";